import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { Button, Card } from '../components/ui';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-secondary-50 dark:bg-secondary-900 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-danger-100 dark:bg-danger-900/30 rounded-full flex items-center justify-center mb-6">
          <ShieldExclamationIcon className="w-8 h-8 text-danger-600 dark:text-danger-400" />
        </div>

        <h1 className="text-2xl font-display font-semibold text-secondary-900 dark:text-secondary-50 mb-2">
          Access Denied
        </h1>

        <p className="text-secondary-600 dark:text-secondary-400 mb-6">
          You don't have permission to access this page. Please contact your administrator
          if you believe this is an error.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Unauthorized;
